var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"pagination"}},[_c('div',{staticClass:"pagination-container"},[_c('atomic-pager',{attrs:{"name":"pagination"}}),_vm._v(" "),_c('atomic-results-per-page',{staticClass:"d-none",attrs:{"choices-displayed":"12,30,45"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-621cb218","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/hcxf/atomic-pagination.vue
// module id = 566
// module chunks = 0 1